<template lang="pug">
div(:class="{ 'mt-6': appointmentDetails.frequency }")
  div.text-sm.font-semibold.neutral700--text(v-if="appointmentDetails.frequency") Appointment {{ index + 1 }}
  v-row.mt-2(dense align="center")
    v-col(:cols="appointmentDetails.frequency ? '4' : '6'")
      div.text-sm.neutral700--text {{ apptSession.services.map(m => m.product.name).join(', ') }}
      div.text-xs.neutral700--text.mt-1 {{ apptSession.provider.name }}, {{ getDuration }}
    v-col(cols="3")
      set-appointment-date(v-model="selectedDate" placeholder="Select date" hide-details="true" :required="false" :loading="isFetchingDates" :disabled="!Boolean(appointmentDetails.frequency)" :picker-date.sync="pickerDate" :min-date="getMinDate()" :unavailable-dates="unavailableDates" @change="fetchTimes(selectedDate, true)")
    v-col(cols="3")
      y-select(v-model="selectedTime" :items="times" item-text="text" item-value="value" placeholder="Select time" :rules="(!selectedDate || setLater) ? [] : rules.not_empty_select" :loading="isFetchingTimes" :disabled="!selectedDate || setLater" :hide-details="true" no-data-text="No timeslot available" @change="setTime(selectedTime)")
    v-col(cols="2" v-if="appointmentDetails.frequency")
      y-checkbox.mb-n2(v-model="setLater" @change="setTime(null)")
        template(#label)
          .text-sm.neutral700--text Set later
    
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SetAppointmentDate from '@/components/clinic/appointment/advance/SetAppointmentDate.vue'

export default {
  components: { SetAppointmentDate },
  props: {
    index: {
      default: 0
    },
    session: {
      required: true,
      type: Object,
      default: (() => {})
    },
    setLaterAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFetchingDates: false,
      isFetchingTimes: false,
      setLater: false,
      selectedDate: null,
      selectedTime: null,
      pickerDate: null,
      unavailableDates: [],
      times: [],
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      appointmentDetails: 'clinic/getTempAppointmentDetails'
    }),
    apptSession: {
      get () {
        return this.session
      },
      set (val) {
        this.$emit('update:session', val)
      }
    },
    getDuration () {
      let text = ''
      if (this.appointmentDetails.frequency) {
        text = this.appointmentDetails.recurring_data.total_min + ' minutes'
      } else {
        if (this.apptSession.services.length) {
          let row = this.appointmentDetails.services_providers.find(f => f.service === this.apptSession.services[0].id)
          if (row) {
            text = `${row.serviceDetails.duration_value} ${row.serviceDetails.duration_unit}`
          }
        }
      }
      return text
    },
  },
  watch: {
    pickerDate (val) {
      this.fetchUnavailableDates(val)
    },
    setLaterAll (val) {
      if (val) {
        this.setLater = true
      } else {
        this.setLater = false
      }
      this.setTime(null)
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.apptSession) {
        if (this.apptSession.start) {
          this.fetchTimes(this.apptSession.start.substr(0, 10))
          this.selectedDate = this.apptSession.start.substr(0, 10)
          this.selectedTime = this.apptSession.start.substr(-8)
        } else if (this.apptSession.preset_date) {
          this.fetchTimes(this.apptSession.preset_date)
          this.selectedDate = this.apptSession.preset_date
        }
        if (this.apptSession.set_later) {
          this.setLater = this.apptSession.set_later
        }
      }
    },
    fetchUnavailableDates (yearMonth) {
      this.times = []
      this.isFetchingDates = true
      let params = { services: this.apptSession.services.map(m => m.id).join(), provider: this.apptSession.provider.id }
      if (yearMonth) {
        params.year = yearMonth.substr(0, 4),
        params.month = yearMonth.substr(-2)
      }
      this.$axios.get(`/clinics/${this.company.slug}/block_dates`, { params })
        .then(resp => {
          this.unavailableDates = resp.data
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingDates = false
        })
    },
    fetchTimes (date, clearTime) {
      if (clearTime) {
        this.setDate(date)
      }
      this.isFetchingTimes = true
      let params = {
        services: this.apptSession.services.map(m => m.id).join() || null,
        date: date || null
      }
      this.$axios.get(`/clinics/${this.company.slug}/providers/${this.apptSession.provider.id}/available_times`, { params })
        .then((resp) => {
          this.times = resp.data.times.map(m => { return { text: this.$options.filters.displayTime2(m), value: m } })
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingTimes = false
        })
    },
    getMinDate () {
      // if (this.selectedService && (this.selectedService.preparation_time_unit === 'days' || this.selectedService.preparation_time_unit === 'weeks' || this.selectedService.preparation_time_unit === 'months')) {
      //   let days = 0
      //   let weeks = 0
      //   let months = 0
      //   if (this.selectedService.preparation_time_unit === 'days') {
      //     days = this.selectedService.preparation_time_value
      //   } else if (this.selectedService.preparation_time_unit === 'weeks') {
      //     weeks = this.selectedService.preparation_time_value
      //   } else if (this.selectedService.preparation_time_unit === 'months') {
      //     months = this.selectedService.preparation_time_value
      //   }
      //   let date = DateTime.local()
      //   date = date.plus({days: days, weeks: weeks, months: months})
      //   return date.toFormat('yyyy-MM-dd')
      // } else {
      //   const today = new Date()
      //   const year = today.getFullYear()
      //   const month = String(today.getMonth() + 1).padStart(2, '0')
      //   const day = String(today.getDate()).padStart(2, '0')
      //   return `${year}-${month}-${day}`;
      // }
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`;
    },
    setDate (date) {
      this.selectedTime = null
      if (date) {
        this.$set(this.apptSession, 'preset_date', date)
      } else {
        this.$set(this.apptSession, 'start', null)
        this.$set(this.apptSession, 'preset_date', null)
      }
    },
    setTime (time) {
      if (time) {
        this.$set(this.apptSession, 'start', `${this.selectedDate} ${time}`)
        this.$set(this.apptSession, 'preset_date', null)
        this.$set(this.apptSession, 'set_later', false)
      } else {
        this.$set(this.apptSession, 'start', null)
        this.$set(this.apptSession, 'preset_date', this.selectedDate)
        this.$set(this.apptSession, 'set_later', true)
        this.selectedTime = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>